import React from "react";

export const ExternalLinkButton = ({
  children,
  className = "",
  inverted = false,
  href,
}: {
  children: React.ReactNode;
  className?: string;
  href: string;
  inverted?: boolean;
}) => (
  <a
    href={href}
    className={`${className} inline-block whitespace-no-wrap cursor-pointer ${
      inverted
        ? "bg-white hover:bg-gray-300 text-blue-400"
        : "bg-blue-500 hover:bg-blue-700 text-white font-bold"
    } py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
  >
    {children}
  </a>
);
